<template>
    <div class="border shadow-lg hover:shadow-md bg-white rounded-b-lg relative my-10 lg:mt-20 lg:mb-36">
        <div class="border-t-8 border-blue-400 p-8 lg:p-12 lg:flex lg:items-center">
            <div class="mr-12 mb-6 lg:mb-0 text-center lg:text-left w-full lg:w-1/4">
                <img
                    :src="imageUrl"
                    :alt="topic.heading"
                    class="mx-auto"
                />
            </div>
            <div class="w-full lg:w-3/4">
                <h3
                    class="uppercase text-blue-400 mb-4 text-sm"
                >
                    Fremhevet tema
                </h3>
                <h2
                    v-html="topic.heading"
                    class="font-bold text-blue-400 text-2xl mb-2"
                ></h2>
                <p
                    v-html="topic.extract"
                    class="leading-6"
                ></p>
            </div>
        </div>
        <a
            :href="topic.url"
            :title="topic.heading"
            class="absolute w-full h-full top-0 left-0 cursor-pointer"
        >
            <span class="sr-only">
                Les mer
            </span>
        </a>
    </div>
</template>

<script>
export default {
    props: ['topic'],
    computed: {
        imageUrl() {
            return this.topic.image + '?width=638&height=425&' + this.topic.imageResizerParams;
        }
    }

};
</script>
